import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";
import { selectorIsRequirementExpiringInDays } from "./selectorIsRequirementExpiringInDays";

export const selectorIsRequirementExpiringInDaysFormatted = (
  requirement: IRequirementResponse
) => {
  const days = selectorIsRequirementExpiringInDays(requirement);

  return days <= 1 ? "today" : `in ${days}d`;
};
